<template>
  <el-pagination
    class="right-pager"
    :current-page="$data.current"
    :page-size="$data.size"
    :layout="layout"
    :total="total"
    v-bind="$attrs"
    @size-change="(val) => { handleSizeChange(val) }"
    @current-change="(val) => { handleCurrentChange(val) }"
  />
</template>

<script>
export default {
  name: 'GjwPagination',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      },
    },
    layout: {
      type: String,
      default: 'sizes, prev, pager, next',
    },
  },
  data() {
    return {
      current: 1,
      size: 10
    }
  },
  watch: {
    currentPage: {
      handler(newVal) {
        this.current = newVal || 1
      },
      immediate: true
    },
    pageSize: {
      handler(newVal) {
        this.size = newVal || 10
      },
      immediate: true
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.current = val
      const payload = {
        changeType: 'current',
        pageNo: val,
        pageSize: this.pageSize
      }
      this.$emit('change', payload)
    },
    handleSizeChange(val) {
      // size改变，需要将currentPage重置为1
      this.current = 1
      this.size = val
      const payload = {
        changeType: 'size',
        pageNo: 1,
        pageSize: val
      }
      this.$emit('change', payload)
    },
  },
}
</script>

<style lang="less" scoped>
.right-pager {
  margin-top: 14px;
  text-align: right;
}
</style>
